export default __webpack_public_path__ + "6d3463288bdd186286eb23d05c1080cc.png";